module.exports = __webpack_public_path__ + "img/1MDB-LL-to-develop.5fdb0625.jpg";